import React, { useCallback, useMemo, useState } from 'react';

import PropTypes from 'prop-types';

import { clearFilterByType, toggleFilterValue } from '../../../../shared/utils';
import FilterContext from './FilterContext';

const INITIAL_ACTIVE_FILTERS = {
  creators: [],
  tags: [],
};

const FilterProvider = ({ children }) => {
  const [activeFilters, setActiveFilters] = useState(INITIAL_ACTIVE_FILTERS);

  const clearFilters = useCallback((type) => {
    setActiveFilters((prev) => clearFilterByType(prev, type));
  }, []);

  const toggleFilter = useCallback(({ type, value }) => {
    setActiveFilters((prev) => toggleFilterValue(prev, { type, value }));
  }, []);

  const contextValue = useMemo(
    () => ({
      activeFilters,
      clearFilters,
      toggleFilter,
    }),
    [activeFilters, clearFilters, toggleFilter]
  );

  return <FilterContext.Provider value={contextValue}>{children}</FilterContext.Provider>;
};

FilterProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default FilterProvider;
